import {Reducer} from 'redux'
import {GlobalActionTypes, GlobalState} from './types';
import {UsersActionTypes} from "../users";
import UsersService from "../../services/UsersService";
import {User} from "../../models/User";

// Type-safe initialState!
const initialState: GlobalState = {
	loading: 0,
	mainMenuOpened: true,
	accessToken: '',
	loginError: false,
	currentUser: null,
	forgotPasswordError: false,
	forgotPasswordCompleted: false,
	resetPasswordUser: null,
	resetPasswordUserError: false,
	resetPasswordError: false,
	resetPasswordCompleted: false
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<GlobalState> = (state = initialState, action) => {
	switch (action.type) {
		case GlobalActionTypes.START_LOADING: {
			return { ...state, loading: state.loading + 1}
		}
		case GlobalActionTypes.END_LOADING: {
			let newLoading = state.loading - 1
			if (newLoading < 0) newLoading = 0
			return { ...state, loading: newLoading}
		}
		case GlobalActionTypes.SHRINK_MAIN_MENU: {
			return { ...state, mainMenuOpened: false}
		}
		case GlobalActionTypes.EXTEND_MAIN_MENU: {
			return { ...state, mainMenuOpened: true}
		}
		case GlobalActionTypes.LOGIN_REQUEST: {
			UsersService.login(action.payload.username, action.payload.password)
			return { ...state, loginError: false}
		}
		case GlobalActionTypes.LOGIN_COMPLETED: {
			let {accessToken, loginError} = action.payload
			return { ...state, accessToken: accessToken.slice(0), loginError: loginError}
		}
		case GlobalActionTypes.SET_ACCESS_TOKEN: {
			let accessToken: string = action.payload
			return { ...state, accessToken: accessToken }
		}
		case GlobalActionTypes.CURRENT_USER_REQUEST: {
			UsersService.currentUser()
			return { ...state}
		}
		case GlobalActionTypes.CURRENT_USER_COMPLETED: {
			let user: User = action.payload
			return { ...state, currentUser: user }
		}
		case GlobalActionTypes.FORGOT_PASSWORD_REQUEST: {
			const {username, error, completed} = action.payload;
			UsersService.forgotPasswordRequest(username)
			return { ...state, forgotPasswordError: error, forgotPasswordCompleted: completed}
		}
		case GlobalActionTypes.FORGOT_PASSWORD_COMPLETED: {
			const {error, completed} = action.payload;
			return { ...state, forgotPasswordError: error, forgotPasswordCompleted: completed}
		}
		case GlobalActionTypes.FORGOT_PASSWORD_REQUEST_RESET: {
			const {error, completed} = action.payload;
			return { ...state, forgotPasswordError: error, forgotPasswordCompleted: completed }
		}
		case GlobalActionTypes.FETCH_BY_RESET_PASSWORD_TOKEN: {
			UsersService.getByResetPasswordToken(action.payload)
			return { ...state }
		}
		case GlobalActionTypes.FETCH_BY_RESET_PASSWORD_TOKEN_COMPLETED: {
			const {user, error} = action.payload;
			return { ...state, resetPasswordUser: user, resetPasswordUserError: error }
		}
		case GlobalActionTypes.RESET_PASSWORD_REQUEST: {
			const {userId, password} = action.payload;
			UsersService.resetPasswordRequest(userId, password)
			return { ...state }
		}
		case GlobalActionTypes.RESET_PASSWORD_COMPLETED: {
			const {error, completed} = action.payload;
			return { ...state, resetPasswordError: error, resetPasswordCompleted: completed}
		}
		case GlobalActionTypes.RESET_PASSWORD_REQUEST_RESET: {
			const {error, completed} = action.payload;
			return { ...state, resetPasswordError: error, resetPasswordCompleted: completed}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as GlobalReducer}
